export default __webpack_public_path__ + "static/media/faqs.a843ab68.jpg";